import React from 'react';
import { copyToClipboard, showSuccess } from 'utils';
import styles from './index.module.scss';

const CopyToClipBoard = props => {
  const { copyText, successMessage } = props;
  const copySuccessMessage = successMessage || 'Copied to Clipboard';

  return (
    <i
      className={`fa fa-files-o ${styles['copy-icon']}`}
      onClick={() => copyToClipboard(copyText, copySuccessMessage)}
    />
  );
};

export default CopyToClipBoard;